import { Translate, trans } from '@lingoda/i18n';
import { StepComponent } from './StepComponent';

export const Step2 = () => (
    <StepComponent title={trans('product-tour-step2-title', {}, 'student-common')}>
        <Translate id="product-tour-step2-description" domain="student-common" component="div" />
    </StepComponent>
);
